"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeNationalInsuranceNumber = normalizeNationalInsuranceNumber;
exports.formatNationalInsuranceNumber = formatNationalInsuranceNumber;
exports.isValidNationalInsuranceNumber = isValidNationalInsuranceNumber;
exports.isNationalInsuranceNumberType = isNationalInsuranceNumberType;
const NINO_PATTERN = /^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z]\d{6}[A-D]$/;
const BLOCKED_PREFIXES = new Set(['BG', 'GB', 'KN', 'NK', 'NT', 'TN', 'ZZ']);
function normalizeNationalInsuranceNumber(value) {
    return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}
function formatNationalInsuranceNumber(value) {
    const normalized = normalizeNationalInsuranceNumber(value).slice(0, 9);
    return [
        normalized.slice(0, 2),
        normalized.slice(2, 4),
        normalized.slice(4, 6),
        normalized.slice(6, 8),
        normalized.slice(8, 9),
    ]
        .filter(Boolean)
        .join(' ');
}
function isValidNationalInsuranceNumber(value) {
    const normalized = normalizeNationalInsuranceNumber(value);
    return NINO_PATTERN.test(normalized) && !BLOCKED_PREFIXES.has(normalized.slice(0, 2));
}
function isNationalInsuranceNumberType(...values) {
    return values
        .map((value) => value.toLowerCase().replace(/[^a-z0-9]/g, ''))
        .some((value) => value === 'nino' || value === 'nationalinsurancenumber');
}
